<!--
 * @Date: 2022-07-27 14:20:25
 * @LastEditors: lizixuan 240514049@qq.com
 * @LastEditTime: 2022-07-29 14:34:03
 * @FilePath: \hw_game_mp_gamebrain_data\frontend\src\views\Message\Index.vue
 * @Description: 
-->
<template>
  <div id="main-content">
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;border-radius: 10px;">
      <a-form-item>
        <a-radio-group button-style="solid" v-model="filter.isSystem" @change="getList(1)">
          <a-radio-button value="">
            全部
          </a-radio-button>
          <a-radio-button value="1">
            系统消息
          </a-radio-button>
          <a-radio-button value="2">
            其他消息
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <!-- <a-form-item>
        <a-input style="width: 200px;" v-model="filter.name" placeholder="操作人" @pressEnter="getList"></a-input>
      </a-form-item> -->
      <a-form-item style="float: right;margin: 0">
        <a-button icon="notification" type="primary" primary html-type="submit" @click="clickSend()">发送消息</a-button>
      </a-form-item>
    </a-form>
    <div style="background-color:#ffffff;padding:20px">
      <!-- <div v-for="(item, index) in dataList" :key="index" :index="index" class="column"> -->
      <div>
        <a-list item-layout="horizontal" :data-source="dataList">
          <a-list-item slot="renderItem" slot-scope="item, index">
            <a-list-item-meta :description="item.content">
              <span slot="title" href="#">
                <a-row>
                  <a-col :span="16">
                    <span v-if="item.is_system == 1">系统消息</span>
                    <span v-else>{{ item.name }}</span>
                  </a-col>
                  <a-col :span="8" style="text-align: right;padding-right:10px">{{ item.created_at }}</a-col>
                </a-row>
              </span>
              <a-avatar slot="avatar" v-if="item.grade == 'info' || item.grade == ''||item.grade == null" style="backgroundColor:#1890ff" icon="info" />
              <a-avatar slot="avatar" v-if="item.grade == 'error'" style="backgroundColor:#f5222d"
                icon="close" />
              <a-avatar slot="avatar" v-if="item.grade == 'success'" style="backgroundColor:#52c41a"
                icon="check" />
              <a-avatar slot="avatar" v-if="item.grade == 'warning'" style="backgroundColor:#faad14" icon="warning" />
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </div>
      <a-divider />
      <a-pagination v-model="filter.page" style="text-align: right" show-size-changer :total="count"
        :page-size="filter.pageSize" @change="changePage" @showSizeChange="changePage" />
    </div>
    <SendMessage
          :show-dialog="sendShow"
          @close-dialog="closeSend()"></SendMessage>
  </div>
  <!-- </div> -->
</template>

<script>
import { SocketList } from "../../api/v1/message_api";
import SendMessage from "../../components/V1/SendMessage";

export default {
  name: "Index",
  components: {SendMessage},
  data() {
    return {
      filter: {
        grade: '',
        isSystem: '',
        page: 1,
        pageSize: 10,
      },
      dataField: [
        { title: 'ID', dataIndex: 'id' },
        { title: '操作人', dataIndex: 'name' },
        { title: '内容', dataIndex: 'content', scopedSlots: { customRender: 'content' } },
        { title: '时间', dataIndex: 'created_at' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' } },
      ],
      dataList: [],
      count: 0,
      sendShow: false,
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    changePage(page, pageSize) {
      this.filter.page = page
      this.filter.pageSize = pageSize
      this.getList()
    },
    getList(page) {
      if (page) {
        this.filter.page = page
      }
      SocketList(this.filter).then(resp => {
        if (resp.code === 200) {
          this.count = resp.data.count
          this.dataList = resp.data.list
          this.filter.page = parseInt(resp.data.page)
          this.filter.pageSize = parseInt(resp.data.pageSize)
        }
      })

    },
    clickSend() {
      this.sendShow = true
    },
    closeSend() {
      this.sendShow = false
      this.getList()
    }
  }
}
</script>

<style scoped>
.overflow {

  width: 300px;

  overflow: hidden;

  white-space: nowrap;

  text-overflow: ellipsis;

  -o-text-overflow: ellipsis;

}

.column {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Message/Index.vue